<template>
  <div class="px-5 py-5">
    <div class="bg-white">
      <h2 class="font-bold text-center mb-5">Donations ({{donationsData.total}})</h2>
      <div class="flex flex-col space-y-8">
        <div class="flex flex-row mx-auto w-full xl:w-1/2 flex-wrap space-y-3">
          <label for="searchTerm" class="sr-only">Donation ID, Donation ID, Name</label>
          <input type="text" v-model="searchTerm" v-on:keyup.enter="search" id="searchTerm" class="w-auto flex-1 sm:text-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500" placeholder="Donation ID, Campaign ID, Name">

          <div class="flex mx-auto ml-3">
            <a @click="search"  href="#" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-pink-500 hover:bg-pink-700 focus:outline-none  focus:ring-pink-200">
              Search
            </a>

            <div class="inline-flex shadow ml-3">
              <a @click="openFilterModal = true" href="#" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-blue-500 hover:bg-blue-700 focus:outline-none  focus:ring-blue-200">
                Filter ({{this.filterCount}})
              </a>
            </div>
          </div>
        </div>
        <div class="mx-auto">
          <a href="#" @click="download" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-green-200">
            Download Results
          </a>
        </div>


        <div class="md:border border-gray-200">
          <div class="hidden md:flex md:flex-row px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray uppercase tracking-wider justify-between border-b border-gray-200">
          <div class="md:pl-2 md:w-1/12">Type</div>
          <div class="md:pl-2 md:w-1/12">ID</div>
          <div class="md:w-1/12">Amount</div>
          <div class="md:w-2/12 md:px-1">Name</div>
          <div class="md:w-3/12 md:px-1">Business Name</div>
          <div class="md:w-2/12">Date</div>
          <div class="md:w-1/12">&nbsp;</div>
          </div>
          <div class="flex flex-col space-y-3 md:space-y-0">
        
          <div v-for="donation in donations" class="flex flex-col md:flex-row md:px-6 md:py-3 bg-white text-left text-sm text-gray justify-between items-center hover:bg-gray-100 border border-gray-200 md:border-b md:border-gray-50 md:border-l-0 md:border-t-0 md:border-r-0 md:items-start">
        
            <div class="flex flex-row w-full items-center md:pl-2 md:w-1/12 border-b border-gray-200 md:border-0 bg-gray-100 md:bg-transparent md:text-base items-stretch">
            <div class="md:hidden flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 flex-1 text-center text-gray-500 font-medium">
              Type
            </div>
            <div class="flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 bg-gray-25 md:bg-transparent text-gray-500 text-center md:pl-1.5 text-lg md:pt-1">
              <div class="flex items-center">
                <i v-show="donation.payment_type_id ==1" title="Credit Card Donation" class="text-pink-500 fas fa-credit-card"></i>
                <i v-show="donation.payment_type_id == 2" title="Check Donation" class="text-blue-500 fas fa-money-check"></i>
                <i v-show="donation.payment_type_id == 4" title="ACH Transfer" class="text-gold-500 fas fa-university"></i>
                <i v-show="donation.payment_type_id ==3" title="Cash Donation" class="text-green-500 fas fa-money-bill"></i>
                <span v-if="donation.payment_type_id == 1 && donation.wallet_type" class="ml-4 flex items-center">
                  <i v-if="donation.wallet_type === 'link'" class="fa-brands fa-stripe text-4xl" style="color: #635BFF;" title="Stripe Link"></i>
                  <i v-else-if="donation.wallet_type === 'google_pay'" class="fa-brands fa-google-pay text-4xl" style="color: #4285F4;" title="Google Pay"></i>
                  <i v-else-if="donation.wallet_type === 'apple_pay'" class="fa-brands fa-apple-pay text-4xl" style="color: #000000;" title="Apple Pay"></i>
                </span>
              </div>
            </div>
            </div>
            <div class="flex flex-row w-full items-center md:pl-2 md:w-1/12 border-b border-gray-200 md:border-0 bg-gray-100 md:bg-transparent md:text-base items-stretch">
            <div class="md:hidden flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 flex-1 text-center text-gray-500 font-medium">
              ID
            </div>
            <div class="flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 bg-gray-25 md:bg-transparent text-gray-500 text-center md:text-left  whitespace-nowrap">
              {{ donation.id }}
            </div>
            </div>
            <div class="flex flex-row w-full items-center md:w-1/12 border-b border-gray-200 md:border-0 bg-gray-100 md:bg-transparent md:text-base items-stretch">
            <div class="md:hidden flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 flex-1 text-center text-gray-500 font-medium">
              Amount
            </div>
            <div class="flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 bg-gray-25 md:bg-transparent text-gray-500 text-center md:text-left whitespace-nowrap">
              $  {{ donation.amount/100 }} &nbsp;
              <a v-show="donation.paid_for_transaction_fee" v-tooltip="getContentDonationTransactionFee(donation)">
              <i class="fas fa-plus-circle"></i>
              </a>
            </div>
            </div>
            <div class="flex flex-row w-full items-center md:w-2/12 border-b border-gray-200 md:border-0 bg-gray-100 md:bg-transparent md:text-base md:px-1">
            <div class="md:hidden flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 flex-1 text-center text-gray-500 font-medium">
              Name
            </div>
            <div class="flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 bg-gray-25 md:bg-transparent text-gray-500 text-center md:text-left">
              {{ donation.first_name ? donation.first_name+'  '+donation.last_name  : '&nbsp' }}
              <i v-show="donation.is_anonymous" class="fas fa-user-secret text-gray-600 ml-2"></i>
            </div>
            </div>
            <div class="flex flex-row w-full items-center md:w-3/12 border-b border-gray-200 md:border-0 bg-gray-100 md:bg-transparent md:text-base md:px-1">
            <div class="md:hidden flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 flex-1 text-center text-gray-500 font-medium">
              Business Name
            </div>
            <div class="flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 bg-gray-25 md:bg-transparent text-gray-500 text-center md:text-left">
              {{ donation.business_name ? donation.business_name : '&nbsp' }}
            </div>
            </div>
            <div class="flex flex-row w-full items-center md:w-2/12 border-b border-gray-200 md:border-0 bg-gray-100 md:bg-transparent md:text-base items-stretch">
            <div class="md:hidden flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 flex-1 text-center text-gray-500 font-medium">
              Date
            </div>
            <div class="flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 bg-gray-25 md:bg-transparent text-gray-500 text-center md:text-left  whitespace-nowrap">
              {{ formatDate(donation.created_at) }}
            </div>
            </div>
            <div class="flex flex-row w-full items-center md:w-1/12 bg-gray-100 md:bg-transparent justify-end md:text-base">
            <div class="md:hidden flex items-center justify-center md:justify-start w-1/2 md:w-full px-6 py-3 md:px-0 md:py-0 flex-1 text-center text-gray-500 font-medium">
              Actions
            </div>
            <div class="flex items-center justify-center md:justify-start w-1/2 md:w-auto px-6 py-3 md:px-0 md:py-0 bg-gray-25 md:bg-transparent text-center text-gray-500">
              <donation-search-crud-button  :user="user" :donation="donation" :key="donation.id" ></donation-search-crud-button>
            </div>
            </div>
          </div>
        
          </div>
        </div>

        <button v-if="this.next_page_url" @click="loadMore" type="button" id="loadMore" class="mx-auto items-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-green-200">
          Load More ({{donationsData.to}} of {{donationsData.total}})
        </button>

      </div>
    </div>

    <transition v-if="openFilterModal"
                enter-class="transition ease-out duration-100 transform"
                enter-active-class="opacity-0"
                enter-to-class="opacity-100"
                leave-class="transition ease-in duration-200 transform"
                leave-active-class="opacity-100"
                leave-to-class="opacity-0"
    >
      <div  class="fixed z-50 inset-0 overflow-y-auto"  id="donation-search-modal">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

          <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle xl:max-w-lg w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="sm:flex sm:items-start">
              <div class="text-center sm:mt-0 sm:text-left w-full">
                <div class="flex justify-between items-center pb-3">
                  <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                    Filter Results
                  </h3>
                  <div @click="openFilterModal = false" class="modal-close cursor-pointer z-50" id="close-donation-modal">
                    <svg  class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                  </div>
                </div>
                <div class="my-3">

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="donation_id" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Donation ID
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="donationId" type="text" name="donation_id" id="donation_id" autocomplete="" class="max-w-lg block w-full shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="campaign_id" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Campaign ID
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="campaignId" type="text"  id="campaign_id" class="max-w-lg block w-full shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>


                  <!-- Date Picker -->
                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Date
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <flat-pickr v-model="date" :config="{mode: 'range'}" class="max-w-lg block w-full shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:max-w-xs sm:text-sm border-gray-300"></flat-pickr>
                    </div>
                  </div>
                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="donation_type" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Payment Type
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <select v-model="paymentTypeId" id="donation_type" name="donation_type" autocomplete="" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:text-sm">
                        <option value=""></option>
                        <option value="1">Credit Card</option>
                        <option value="2">Check</option>
                        <option value="3">Cash</option>
                        <option value="4">ACH</option>
                      </select>
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="state" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      State
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <select id="state"  v-model="state" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:text-sm">
                        <option value=""></option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AS">American Samoa</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District of Columbia</option>
                        <option value="FM">Federated States of Micronesia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="GU">Guam</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MH">Marshall Islands</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="MP">Northern Mariana Islands</option>
                        <option value="OH" selected="selected">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PW">Palau</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="PR">Puerto Rico</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VI">Virgin Islands</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                      </select>
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="amount" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Amount ($)
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="amount" type="text" id="amount"  class="max-w-lg block w-full shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="checkNumber" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Check Number
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="checkNumber" type="text" id="checkNumber" class="max-w-lg block w-full shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button @click="search" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-700 focus:outline-none  focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm">
                Filter
              </button>
              <button @click="resetFilters"  class="mt-3 w-full inline-flex justify-center border border-pink-500 shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500 sm:mt-0 sm:w-auto sm:text-sm">
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

    </transition>

    <div v-if="isExporting || showExportModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-96">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold">{{ exportStatus }}</h3>
          <button @click="hideExportModal" class="text-gray-500 hover:text-gray-700">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 mb-4">
          <div class="bg-blue-600 h-2.5 rounded-full" :style="{ width: exportProgress + '%' }"></div>
        </div>
        <p class="text-sm text-gray-600">{{ exportMessage }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
import flatPickr from 'vue-flatpickr-component';
import 'floating-vue/dist/style.css'

export default {
  props: {
    allDonations: {},
    user: {},
  },
  components: {
    flatPickr
  },
  data() {
    return {
      options: {
        classes: ''
      },
      donationsData: this.allDonations,
      donations: this.allDonations?.data,
      isOpen: false,
      openFilterModal: false,

      next_page_url: this.allDonations?.next_page_url ?  '/donation-search-with-term?page=2' : '',
      searchTerm: '',
      campaignId: '',
      state: '',
      amount: '',
      checkNumber: '',
      paymentTypeId: '',
      donationId: '',
      date: '',
      filterCount: 0,
      isExporting: false,
      exportStatus: '',
      exportProgress: 0,
      exportMessage: '',
      showExportModal: false,
      exportFailed: false,
      exportCheckInterval: null,
      lastExportState: null
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MM-DD-YYYY')
    },
    getFilterRequestQuery() {
      this.filterCount = 0

      let query = ''
      if (this.amount ) {
        query = query + '&amount='+this.amount
        this.filterCount++
      }
      if (this.state ) {
        query = query + '&state='+this.state
        this.filterCount++
      }
      if (this.paymentTypeId ) {
        query = query + '&paymentTypeId='+this.paymentTypeId
        this.filterCount++
      }
      if (this.donationId ) {
        query = query + '&donationId='+this.donationId
        this.filterCount++
      }
      if (this.date ) {
        query = query + '&date='+this.date
        this.filterCount++
      }
      if (this.checkNumber ) {
        query = query + '&checkNumber='+this.checkNumber
        this.filterCount++
      }
      if (this.campaignId ) {
        query = query + '&campaignId='+this.campaignId
        this.filterCount++
      }
      return query
    },
    resetFilters() {
      this.campaignId =  ''
      this.state =  ''
      this.amount =  ''
      this.checkNumber =  ''
      this.paymentTypeId =  ''
      this.donationId =  ''
      this.date = ''
    },
    search() {
      axios.get('/donation-search-with-term?search_term='+this.searchTerm+this.getFilterRequestQuery())
          .then(response => {
            this.donations =   response.data.data
            this.donationsData =   response.data
            this.next_page_url = response.data.next_page_url
            this.isLoading = false
            this.isLoadingMore = false

            this.openFilterModal = false
          })
    },
    loadMore() {
      if (this.next_page_url) {
        axios.get(this.next_page_url+'&search_term='+this.searchTerm)
            .then(response => {
              this.donationsData =   response.data

              response.data.data.map((value, key) => {
                this.donations.push(value)
              })
              this.next_page_url = response.data.next_page_url
              this.isLoading = false
              this.isLoadingMore = false

              if (this.next_page_url) {
                VueScrollTo.scrollTo('#loadMore', 1300)
              }
            })
      } else {
        this.isLoading = false
        this.isLoadingMore = false
      }
    },
    download() {
      this.isExporting = true;
      this.showExportModal = true;
      this.exportStatus = 'Starting export...';
      this.exportProgress = 0;

      axios.post('/donation-search-export?search_term='+this.searchTerm+this.getFilterRequestQuery(), {
        file_name: 'donations-export.xlsx'
      }).then((response) => {
        this.checkExportStatus();
      }).catch((error) => {
        this.isExporting = false;
        this.exportStatus = 'Export failed. Please try again.';
      });
    },

    hideExportModal() {
      this.showExportModal = false;
      this.exportProgress = 0;
      this.exportMessage = '';
      this.exportStatus = '';
      if (this.isExporting) {
        this.isExporting = false;
      }
    },

    checkExportStatus() {
      axios.get('/donation-export-status').then((response) => {
        if (response.data.status === 'completed') {
          this.isExporting = false;
          this.exportStatus = 'Export completed!';
          this.exportProgress = 100;
          window.location.href = response.data.download_url;
          setTimeout(() => {
            this.hideExportModal();
          }, 2000);
        } else if (response.data.status === 'pending' || response.data.status === 'queued') {
          this.exportStatus = response.data.message || 'Export in progress...';
          this.exportProgress = response.data.progress || 0;
          this.exportMessage = response.data.message || '';
          setTimeout(() => this.checkExportStatus(), 1000);
        } else {
          this.isExporting = false;
          this.exportStatus = 'Export failed. Please try again.';
          this.exportProgress = 0;
        }
      }).catch((error) => {
        this.isExporting = false;
        this.exportStatus = 'Failed to check export status.';
        this.exportProgress = 0;
      });
    },

    getContentDonationTransactionFee(donation) {
      return '$'+(donation.calculated_transaction_fee/100)
    },

  },

  beforeDestroy() {
    // Clean up interval when component is destroyed
    if (this.exportCheckInterval) {
      clearInterval(this.exportCheckInterval);
    }
  }
}
</script>

<style scoped>

</style>
